import { Customer } from "resource-planner-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";
import {
  fetchAllList,
  fetchListPage,
  PaginatedListRequest,
  PaginatedListResponse
} from "../utils/PaginatedListService";

export interface CustomerService {
  fetch(): Promise<Customer[]>;
  fetchPage(request?: PaginatedListRequest): Promise<PaginatedListResponse<Customer>>;
  delete(id: string): Promise<void>;
  persist(item: Customer): Promise<Customer>;
}

class HTTPCustomerService implements CustomerService {
  constructor(private endpoint: string) {}

  async fetch(): Promise<Customer[]> {
    return fetchAllList<Customer>(`${this.endpoint}/customers`, (url) =>
      fetchService.fetch(url, {}).then((r) => r.json())
    ).catch((): any[] => []);
  }

  async fetchPage(
    request: PaginatedListRequest = {}
  ): Promise<PaginatedListResponse<Customer>> {
    return fetchListPage<Customer>(
      `${this.endpoint}/customers`,
      (url) => fetchService.fetch(url, {}).then((r) => r.json()),
      request
    ).catch(() => ({ items: [] as Customer[] }));
  }

  async delete(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/customers/${id}`, {
        method: "DELETE",
      })
      .then();
  }

  async persist(item: Customer): Promise<Customer> {
    return fetchService
      .fetch(`${this.endpoint}/customers`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then((r) => r.json());
  }
}

const service: CustomerService = new HTTPCustomerService(env.endpoint);

export default service;
